import { render } from "./Gradient.vue?vue&type=template&id=5ac0fe5e&scoped=true"
import script from "./Gradient.vue?vue&type=script&lang=js"
export * from "./Gradient.vue?vue&type=script&lang=js"

import "./Gradient.vue?vue&type=style&index=0&id=5ac0fe5e&scoped=true&lang=css"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac0fe5e"]])

export default __exports__